// CustomDropdown.js

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const CustomDropdown = ({
  options,
  value,
  onChange,
  label,
  placeholder = "Select an option",
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);

  useEffect(() => {
    if (dropdownOpen) {
      // Filter options based on the search query, or show all if there's no query
      if (searchQuery.trim()) {
        setFilteredOptions(
          options.filter((option) =>
            option.toLowerCase().includes(searchQuery.toLowerCase()),
          ),
        );
      } else {
        setFilteredOptions(options);
      }
    }
  }, [searchQuery, dropdownOpen, options]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    onChange(option);
    setDropdownOpen(false);
    setSearchQuery(""); // Clear the search query when an option is selected
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div className="relative w-full">
      {label && (
        <label className="block text-sm font-medium text-agLightGray mb-1">
          {label}
        </label>
      )}
      <div
        className="flex items-center border rounded-md  px-3 py-3 focus-within:outline-none focus-within:border-agPrimary cursor-pointer"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <span
          className={`text-sm ${
            selectedOption ? "text-agBlack" : "text-agLightGray"
          }`}
        >
          {selectedOption || placeholder}
        </span>
        <span className="material-icons-round ml-auto">arrow_drop_down</span>
      </div>
      {dropdownOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white border border-agGray rounded-md shadow-lg max-h-60 overflow-auto">
          <input
            type="text"
            placeholder="Search"
            className="text-sm w-full px-3 py-2 border-b border-agGray focus:outline-none"
            onChange={handleSearchChange}
            value={searchQuery}
          />
          <ul>
            {filteredOptions.map((option, index) => (
              <li
                key={index}
                className="text-sm text-agBlack px-3 py-2 hover:bg-agPrimaryLight cursor-pointer"
                onClick={() => handleOptionChange(option)}
              >
                {option}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export default CustomDropdown;
